import {
  EntitiesSupportingFieldCustomization,
  EntityType,
} from "@mapmycustomers/shared/types/entity";
import FormLayout from "@mapmycustomers/shared/types/layout/FormLayout";
import { doesEntitySupportCustomSourceObject } from "@mapmycustomers/shared/util/assert";

import useActualLayoutSchema from "@app/util/useActualLayoutSchema";

interface UseEntityLayoutSchemaArgs {
  entity: EntitiesSupportingFieldCustomization;
  layout: FormLayout;
}

const useEntityLayoutSchema = ({ entity, layout }: UseEntityLayoutSchemaArgs) => {
  const crmActivityTypeId =
    entity.entity === EntityType.ACTIVITY ? entity.crmActivityType.id : undefined;
  const stageId = entity.entity === EntityType.DEAL ? entity.stage.id : undefined;
  const sourceObject = doesEntitySupportCustomSourceObject(entity)
    ? entity.sourceObject
    : undefined;

  return useActualLayoutSchema({
    crmActivityTypeId,
    entityType: entity.entity,
    layout,
    sourceObject,
    stageId,
  });
};

export default useEntityLayoutSchema;
